export default [
    // {
    //     name: 'environmentMapTexture',
    //     type: 'cubeTexture',
    //     path:
    //     [
    //         'textures/environmentMap/px.jpg',
    //         'textures/environmentMap/nx.jpg',
    //         'textures/environmentMap/py.jpg',
    //         'textures/environmentMap/ny.jpg',
    //         'textures/environmentMap/pz.jpg',
    //         'textures/environmentMap/nz.jpg'
    //     ]
    // },
    // {
    //     name: 'grassColorTexture',
    //     type: 'texture',
    //     path: 'textures/dirt/color.jpg'
    // },
    // {
    //     name: 'grassNormalTexture',
    //     type: 'texture',
    //     path: 'textures/dirt/normal.jpg'
    // },
    // {
    //     name: 'foxModel',
    //     type: 'gltfModel',
    //     path: 'models/Fox/glTF/Fox.gltf'
    // },
    {
        name: 'baseProfile',
        type: 'gltfModel',
        path: 'models/Profile/Base/BaseProfile.glb'
    },
    {
        name: 'basePortfolio',
        type: 'gltfModel',
        path: 'models/Portfolio/Base/BasePortfolio.glb'
    },
    {
        name: 'baseProfile',
        type: 'gltfModel',
        path: 'models/Profile/Base/BaseProfile.glb'
    },
    {
        name: 'reyna',
        type: 'gltfModel',
        path: 'models/Portfolio/Valorant/Reyna/Reyna.glb'
    },
    {
        name: 'chamber',
        type: 'gltfModel',
        path: 'models/Portfolio/Valorant/Chamber/Chamber.glb'
    },
    {
        name: 'breach',
        type: 'gltfModel',
        path: 'models/Portfolio/Valorant/Breach/Breach.glb'
    },
    {
        name: 'rlTrack',
        type: 'gltfModel',
        path: 'models/Portfolio/RL/RLTrack.glb'
    },
    {
        name: 'rlFennec',
        type: 'gltfModel',
        path: 'models/Portfolio/RL/RLFennec.glb'
    },
    {
        name: 'rlOctane',
        type: 'gltfModel',
        path: 'models/Portfolio/RL/RLOctane.glb'
    },
    {
        name: 'jordan',
        type: 'gltfModel',
        path: 'models/Portfolio/Jordan1/Jordan1.glb'
    },
    {
        name: 'jordanBox',
        type: 'gltfModel',
        path: 'models/Portfolio/Jordan1/Jordan1Box.glb'
    },
    {
        name: 'tvScreen',
        type: 'gltfModel',
        path: 'models/Portfolio/TV/TVScreen.glb'
    },
    {
        name: 'jordanGreyBlueTexture',
        type: 'texture',
        path: 'textures/Jordan/J1GreyBlue512.jpg'
    },
    {
        name: 'jordanRedTexture',
        type: 'texture',
        path: 'textures/Jordan/J1Red512.jpg'
    },
    {
        name: 'jordanPurpleTexture',
        type: 'texture',
        path: 'textures/Jordan/J1Purple512.jpg'
    },
    {
        name: 'jordanNormalTexture',
        type: 'texture',
        path: 'textures/Jordan/J1Normal512.png'
    },
    {
        name: 'basePortfolioTexture',
        type: 'texture',
        path: 'textures/Base/BasePortfolioTexture.jpg'
    },
    {
        name: 'baseProfileTexture',
        type: 'texture',
        path: 'textures/Base/BaseProfileTexture.jpg'
    },
    {
        name: 'blenderTexture',
        type: 'texture',
        path: 'textures/Screen/ScreenBlender_480.webp'
    },
    {
        name: 'vscodeTexture',
        type: 'texture',
        path: 'textures/Screen/ScreenVSCode_480.webp'
    },
    {
        name: 'ball',
        type: 'gltfModel',
        path: 'models/Profile/Ball/Ball.glb'
    },
    {
        name: 'chair',
        type: 'gltfModel',
        path: 'models/Profile/Chair/Chair.glb'
    },
    {
        name: 'hat',
        type: 'gltfModel',
        path: 'models/Profile/Hat/Hat.glb'
    },
    {
        name: 'mouse',
        type: 'gltfModel',
        path: 'models/Profile/Mouse/Mouse.glb'
    },
    {
        name: 'pc',
        type: 'gltfModel',
        path: 'models/Profile/PC/PC.glb'
    },
    // {
    //     name: 'monitor',
    //     type: 'gltfModel',
    //     path: 'models/Profile/Monitor/Monitor.glb'
    // },
    // {
    //     name: 'fontMontserrat',
    //     type: 'font',
    //     path: 'fonts/Montserrat-Bold.ttf'
    // }
]